/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  SendCommandStringResponse,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendCommandStringForWebInput {
  loggerId: string;
  deviceSN: string;
  content: string[];
  callBackUrl?: string;
}
const build = (_query: DocumentNode, input: SendCommandStringForWebInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.loggerId !== undefined ? `$loggerId: String = ${JSON.stringify(input.loggerId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.deviceSN !== undefined ? `$deviceSN: String = ${JSON.stringify(input.deviceSN).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.content !== undefined ? `$content:  [ String ]  = ${'[' + input.content.map((item) => JSON.stringify(item).replace(/"(\w+)":/g, '$1:')).join(",") + ']'}, ` : '' ) + ``+
    ( input.callBackUrl !== undefined ? `$callBackUrl: String = ${JSON.stringify(input.callBackUrl).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    sendCommandStringForWeb(
      ${ input.loggerId !== undefined ? 'loggerId: $loggerId,' : '' } 
      ${ input.deviceSN !== undefined ? 'deviceSN: $deviceSN,' : '' } 
      ${ input.content !== undefined ? 'content: $content,' : '' } 
      ${ input.callBackUrl !== undefined ? 'callBackUrl: $callBackUrl,' : '' }
    ){
      ...sendcommandstringresponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendCommandStringForWebMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment sendcommandstringresponse on SendCommandStringResponse { ... }
   */
  async execute(_query: DocumentNode, input: SendCommandStringForWebInput): Promise<apollo.FetchResult< { sendCommandStringForWeb: Partial<SendCommandStringResponse> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendCommandStringForWeb: Partial<SendCommandStringResponse> }>({ mutation: build(_query, input) });
  }
}
